import { render, staticRenderFns } from "./InventoryManage.vue?vue&type=template&id=0a96a0e0&scoped=true"
import script from "./InventoryManage.vue?vue&type=script&lang=js"
export * from "./InventoryManage.vue?vue&type=script&lang=js"
import style0 from "./InventoryManage.vue?vue&type=style&index=0&id=0a96a0e0&prod&scoped=true&lang=scss"
import style1 from "./InventoryManage.vue?vue&type=style&index=1&id=0a96a0e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96a0e0",
  null
  
)

export default component.exports